import React from 'react';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';

const AidaFrameworkIcon = ({
  color = '#FFE600',
  size = 12,
}) => (
  <WbIncandescentIcon size={size} style={{ transform: 'rotate(180deg)', color }} />
);

export default AidaFrameworkIcon;
